<template>
  <div>
    <v-tooltip z-index="100" max-width="300" :disabled="!hasTooltip" top >
      <template v-slot:activator="{ on }">
        <v-btn
          text
          :disabled="disabled"
          :color="color"
          v-on="on"
          elevation="0"
          @click="clickMethod"
          style="overflow-wrap: break-word"
          :class="appearDisabled ? 'appear-disabled' : ''"
        ><v-icon :size="size">{{ icon }}</v-icon
        ><slot name="badge" /><span style="font-size: 75%">{{ label }}</span></v-btn
        >
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'ScheduleActionButton',
  props: {
    label: { type: String, required: false },
    icon: { type: String, required: false },
    clickMethod: { type: Function, required: false },
    disabled: { type: Boolean, required: false },
    color: { type: String, required: false },
    tooltip: { type: String, required: false },
    appearDisabled: { type: Boolean, required: false},
    size: { type: String, required: false, default: 'medium'}
  },
  computed: {
    hasTooltip() {
      return this.tooltip !== undefined  && this.tooltip !== null
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .v-btn__content {
  flex-direction: column;
}
.appear-disabled {
  opacity: 0.5;
}
</style>
